export const formatUSDollar = (price: number, withDecimals?: boolean) => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: 2,
  })

  return `${USDollar.format(price)}`
}
